export const FETCH_SUBSCRIPTION_PLANS = "APP/ENTITIES/SUBSCRIPTION_PLANS/FETCH";
export const FETCH_SUBSCRIPTION_PLANS_SUCCESS =
  "APP/ENTITIES/SUBSCRIPTION_PLANS/FETCH_SUCCESS";
export const FETCH_SUBSCRIPTION_PLANS_FAILURE =
  "APP/ENTITIES/SUBSCRIPTION_PLANS/FETCH_FAILURE";
